<template>
  <el-form class="result-form">
    <table cellpadding="0" cellspacing="0">
      <tr>
        <td class="header">{{ $t('FileHistory.fileName') }}</td>
        <td colspan="3">
          <span style="margin-left: 10px;">{{ details.fileName }}</span>
        </td>
      </tr>
      <tr>
        <td class="header">{{ $t('SeaExport.SerialNo') }}</td>
        <td><span style="margin-left: 10px;">{{ details.fileNo }}</span></td>
        <td class="header">{{ $t('SeaExport.BusinessNumber') }}</td>
        <td><span style="margin-left: 10px;">{{ details.jobNo }}</span></td>
      </tr>
      <tr>
        <td rowspan="7" class="header">{{ $t('Message.Shipper') }}</td>
        <td><el-form-item><el-input v-model="resultJson.shipper.value1" @focus="handleFocus('shipper')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.BLForm') }}</td>
        <td><el-form-item><el-input v-model="resultJson.orderType.value" @focus="handleFocus('orderType')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.shipper.value2" @focus="handleFocus('shipper')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.LCL') }}</td>
        <td><el-form-item><el-input v-model="resultJson.fclOrLcl.value" @focus="handleFocus('fclOrLcl')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.shipper.value3" @focus="handleFocus('shipper')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.ShippingCompany') }}</td>
        <td><el-form-item><el-input v-model="resultJson.shipName.value" @focus="handleFocus('shipName')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.shipper.value4" @focus="handleFocus('shipper')" /></el-form-item></td>
        <td class="header">{{ $t('Payment.vessel') }}</td>
        <td><el-form-item><el-input v-model="resultJson.vessel.value" @focus="handleFocus('vessel')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.shipper.value5" @focus="handleFocus('shipper')" /></el-form-item></td>
        <td class="header">{{ $t('Payment.voyage') }}</td>
        <td><el-form-item><el-input v-model="resultJson.voyage.value" @focus="handleFocus('voyage')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.shipper.value6" @focus="handleFocus('shipper')" /></el-form-item></td>
        <td class="header">{{ $t('queryJob.dateOfDeparture') }}</td>
        <td><el-form-item><el-input v-model="resultJson.etd.value" @focus="handleFocus('etd')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.shipper.value7" @focus="handleFocus('shipper')" /></el-form-item></td>
        <td colspan="2" />
      </tr>
      <tr>
        <td rowspan="7" class="header">{{ $t('Message.Consignee') }}</td>
        <td><el-form-item><el-input v-model="resultJson.consignee.value1" @focus="handleFocus('consignee')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.TransportationClause') }}</td>
        <td><el-form-item><el-input v-model="resultJson.serviceTerm.value" @focus="handleFocus('serviceTerm')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.consignee.value2" @focus="handleFocus('consignee')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.FreightTerm') }}</td>
        <td><el-form-item><el-input v-model="resultJson.paymenTerm.value" @focus="handleFocus('paymenTerm')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.consignee.value3" @focus="handleFocus('consignee')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.ContainerSize') }}</td>
        <td><el-form-item><el-input v-model="resultJson.boxType.value" @focus="handleFocus('boxType')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.consignee.value4" @focus="handleFocus('consignee')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.ContainerAmount') }}</td>
        <td><el-form-item><el-input v-model="resultJson.boxVolume.value" @focus="handleFocus('boxVolume')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.consignee.value5" @focus="handleFocus('consignee')" /></el-form-item></td>
        <td class="header">{{ $t('queryJob.IncoTerm') }}</td>
        <td><el-form-item><el-input v-model="resultJson.deliveryTerm.value" @focus="handleFocus('deliveryTerm')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.consignee.value6" @focus="handleFocus('consignee')" /></el-form-item></td>
        <td class="header">{{ $t('Payment.contactPerson') }}</td>
        <td><el-form-item><el-input v-model="resultJson.contacts.value" @focus="handleFocus('contacts')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.consignee.value7" @focus="handleFocus('consignee')" /></el-form-item></td>
        <td colspan="2" />
      </tr>
      <tr>
        <td rowspan="7" class="header">{{ $t('Message.Notify') }}</td>
        <td><el-form-item><el-input v-model="resultJson.notifyParty.value1" @focus="handleFocus('notifyParty')" /></el-form-item></td>
        <td rowspan="7" class="header">{{ $t('SeaExport.CargoSize') }}</td>
        <td rowspan="7"><el-form-item><el-input v-model="resultJson.goodSize.value" type="textarea" resize="none" :rows="11" @focus="handleFocus('goodSize')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.notifyParty.value2" @focus="handleFocus('notifyParty')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.notifyParty.value3" @focus="handleFocus('notifyParty')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.notifyParty.value4" @focus="handleFocus('notifyParty')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.notifyParty.value5" @focus="handleFocus('notifyParty')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.notifyParty.value6" @focus="handleFocus('notifyParty')" /></el-form-item></td>
      </tr>
      <tr>
        <td><el-form-item><el-input v-model="resultJson.notifyParty.value7" @focus="handleFocus('notifyParty')" /></el-form-item></td>
      </tr>
      <tr>
        <td class="header">{{ $t('Payment.portOfLoading') }}</td>
        <td><el-form-item><el-input v-model="resultJson.portOfLoading.value" @focus="handleFocus('portOfLoading')" /></el-form-item></td>
        <td class="header">{{ $t('Payment.portOfTransfer') }}</td>
        <td><el-form-item><el-input v-model="resultJson.transitPort.value" @focus="handleFocus('transitPort')" /></el-form-item></td>
      </tr>
      <tr>
        <td class="header">{{ $t('queryJob.dischargingPortCode') }}</td>
        <td><el-form-item><el-input v-model="resultJson.portOfDischarge.value" @focus="handleFocus('portOfDischarge')" /></el-form-item></td>
        <td class="header">{{ $t('queryJob.placeOfDelivery') }}</td>
        <td><el-form-item><el-input v-model="resultJson.placeOfDelivery.value" @focus="handleFocus('placeOfDelivery')" /></el-form-item></td>
      </tr>
      <tr>
        <td class="header">{{ $t('SeaExport.Quantity') }}</td>
        <td><el-form-item><el-input v-model="resultJson.numberOfPieces.value" @focus="handleFocus('numberOfPieces')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.Package') }}</td>
        <td><el-form-item><el-input v-model="resultJson.packing.value" @focus="handleFocus('packing')" /></el-form-item></td>
      </tr>
      <tr>
        <td class="header">{{ $t('SeaExport.Weight') }}</td>
        <td><el-form-item><el-input v-model="resultJson.grossWeight.value" @focus="handleFocus('grossWeight')" /></el-form-item></td>
        <td class="header">{{ $t('SeaExport.Cubage') }}</td>
        <td><el-form-item><el-input v-model="resultJson.volume.value" @focus="handleFocus('volume')" /></el-form-item></td>
      </tr>
      <tr>
        <td class="header">{{ $t('SeaExport.Marks') }}</td>
        <td><el-form-item><el-input v-model="resultJson.marks.value" type="textarea" resize="none" :rows="10" @focus="handleFocus('marks')" /></el-form-item></td>
        <td class="header">{{ $t('Pricing.Goods') }}</td>
        <td><el-form-item><el-input v-model="resultJson.goodName.value" type="textarea" resize="none" :rows="10" @focus="handleFocus('goodName')" /></el-form-item></td>
      </tr><tr>
        <td class="header">{{ $t('Payment.remarks') }}</td>
        <td colspan="3"><el-form-item><el-input v-model="resultJson.remarks.value" type="textarea" resize="none" :rows="5" @focus="handleFocus('remarks')" /></el-form-item></td>
      </tr>
    </table>
  </el-form>
</template>

<script>
export default {
  name: 'ResultForm',
  props: {
    details: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      resultJson: null
    }
  },
  watch: {
    details(val, oldVal) {
      if (val.resultJson !== oldVal.resultJson) {
        this.resultJson = JSON.parse(this.details.resultJson)
      }
    }
  },
  created() {
    this.resultJson = JSON.parse(this.details.resultJson)
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    }
  }
}
</script>

<style lang="scss">
.result-form{
  padding: 10px;
  table{
    width: 100%;
    tr{
      td {
        border: 1px solid #DCDFE6;
        height: 30px;
        &.header {
          width: 100px;
          text-align: center;
        }
        .el-form-item{
          margin: 0!important;
          input{
            border:none!important;
          }
        }
      }
    }
  }
}
</style>
